import Loadable, { NullLoader, LoadingSpinner as Loading } from '@comeon/loadable';

const DELAY = 300;

const WeSpinSessionLobby = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./we-spin-session-lobby.js'
		),
	loading: Loading,
	delay: DELAY
});

const WeSpinGameView = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./game-room/we-spin-game-view.js'
		),
	loading: Loading,
	delay: DELAY
});

const WeSpinGameRoomSidebarController = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./game-room/we-spin-game-room-sidebar-controller.js'
		),
	loading: Loading,
	delay: DELAY
});

const WeSpinDesktopGameViewHeader = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./game-room/we-spin-desktop-game-view-header.js'
		),
	loading: Loading,
	delay: DELAY
});

const WeSpinDashboardSessionContainer = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin-dashboard" */
			'./dashboard/session-view-control/we-spin-dashboard-session-container.js'
		),
	loading: Loading
});

const WeSpinDashboardCreateSession = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin-dashboard" */
			'./dashboard/session-crud/we-spin-dashboard-create-session.js'
		),
	loading: Loading
});

const WeSpinDashboardCreateSessionSuccess = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin-dashboard" */
			'./dashboard/session-crud/we-spin-dashboard-create-session-success.js'
		),
	loading: Loading
});

const WeSpinDashboardEditSession = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin-dashboard" */
			'./dashboard/session-crud/we-spin-dashboard-edit-session.js'
		),
	loading: Loading
});

const WeSpinDashboardCreateProfile = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin-dashboard" */
			'./dashboard/profile/we-spin-dashboard-create-profile.js'
		),
	loading: Loading
});

const WeSpinDashboardEditProfile = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin-dashboard" */
			'./dashboard/profile/we-spin-dashboard-edit-profile.js'
		),
	loading: Loading
});

const WeSpinTwitchAuth = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin-dashboard" */
			'./dashboard/profile/we-spin-dashboard-twitch-auth.js'
		),
	loading: Loading
});
const WeSpinTwitchAuthResult = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin-dashboard" */
			'./dashboard/profile/we-spin-dashboard-twitch-auth-result.js'
		),
	loading: Loading
});

const WeSpinDashboardRoutes = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin-dashboard" */
			'./dashboard/we-spin-dashboard-routes.js'
		),
	loading: Loading
});

const WeSpinChangeDisplayName = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./account/we-spin-change-display-name.js'
		),
	loading: NullLoader
});

const WeSpinChangeDisplayNameLinkList = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./account/we-spin-change-display-name-link-list.js'
		),
	loading: NullLoader
});

const WeSpinDashBoardAccountLinkList = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./account/we-spin-dashboard-account-linklist.js'
		),
	loading: NullLoader
});

const WeSpinBalance = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./components/we-spin-balance.js'
		),
	loading: NullLoader
});

const WeSpinRoutes = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./we-spin-routes.js'
		),
	loading: NullLoader
});

const WeSpinNotificationClient = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./components/we-spin-notification-client.js'
		),
	loading: NullLoader
});

const WeSpinTakeMeToEvent = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./components/take-me-to-event.js'
		),
	loading: NullLoader
});

const WeSpinKeepAlive = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./components/keep-alive.js'
		),
	loading: NullLoader
});

const WeSpinConfiguration = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./components/we-spin-configuration.js'
		),
	loading: NullLoader
});

const WeSpinNotificationOptOut = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./account/we-spin-notification-opt-out.js'
		),
	loading: NullLoader
});

const WeSpinNotificationOptOutLinkList = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "we-spin" */
			'./account/we-spin-notification-opt-out-linklist.js'
		),
	loading: NullLoader
});

const WeSpinDashboardViewDetailsOfStream = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "WeSpinDashboardViewDetailsOfStream" */
			'./dashboard/session-view-control/we-spin-dashboard-view-details-of-stream.js'
		),
	loading: NullLoader
});

const WeSpinDashboardScheduled = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "WeSpinDashboardSchedule" */
			'./dashboard/session-view-control/we-spin-dashboard-schedule.js'
		),
	loading: NullLoader
});

const WeSpinDashboardChat = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "WeSpinDashboardChat" */
			'./dashboard/we-spin-dashboard-chat.js'
		),
	loading: NullLoader
});

const WeSpinDashboardSearch = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "WeSpinDashboardSearch" */
			'./dashboard/search/we-spin-dashboard-search-container.js'
		),
	loading: NullLoader
});

export {
	WeSpinRoutes,
	WeSpinDashboardRoutes,
	WeSpinGameView,
	WeSpinSessionLobby,
	WeSpinDashboardCreateProfile,
	WeSpinGameRoomSidebarController,
	WeSpinDesktopGameViewHeader,
	WeSpinChangeDisplayName,
	WeSpinChangeDisplayNameLinkList,
	WeSpinDashBoardAccountLinkList,
	WeSpinBalance,
	WeSpinDashboardSessionContainer,
	WeSpinDashboardCreateSession,
	WeSpinDashboardCreateSessionSuccess,
	WeSpinDashboardEditSession,
	WeSpinDashboardEditProfile,
	WeSpinNotificationClient,
	WeSpinNotificationOptOut,
	WeSpinNotificationOptOutLinkList,
	WeSpinDashboardViewDetailsOfStream,
	WeSpinDashboardScheduled,
	WeSpinDashboardChat,
	WeSpinDashboardSearch,
	WeSpinTakeMeToEvent,
	WeSpinConfiguration,
	WeSpinKeepAlive,
	WeSpinTwitchAuthResult,
	WeSpinTwitchAuth
};
